import { ReactNode } from "react";
import { PublicNavbar } from "./PublicNavbar";
import Footer from "@/components/landing/Footer";
import { SkipLinks } from "@/components/ui/SkipLinks";

interface PublicLayoutProps {
  children: ReactNode;
  variant?: "standard" | "homepage";
  className?: string;
}

export const PublicLayout = ({ 
  children, 
  variant = "standard",
  className 
}: PublicLayoutProps) => {
  // Homepage variant uses dark background for hero section
  const containerClass = variant === "homepage" 
    ? "min-h-screen bg-slate-950"
    : "min-h-screen flex flex-col";
  
  return (
    <div className={className || containerClass}>
      <SkipLinks />
      <PublicNavbar variant={variant} />
      <main id="main-content" role="main" className="flex-1" tabIndex={-1}>
        {children}
      </main>
      <Footer />
    </div>
  );
};